import React, { useState, useEffect } from 'react';
import DoubleRangeSlider from '../double-range-slider/DoubleRangeSlider';
import PriceRangeDropdownShell from './PriceRangeDropdownShell';

type GooglePriceRangeDropdownProps = {
  nbHits: number;
  nbSaleItems: number;
  priceRange: { min: number; max: number };
  setPriceRange: (range: { min?: number; max?: number }) => void;
  setSaleItems: (v: boolean) => void;
  setRangeValues?: (range: { min: number; max: number }) => void;
  searchTerm: string;
};

const GooglePriceRangeDropdown = ({
  nbHits,
  nbSaleItems,
  priceRange,
  setPriceRange,
  setSaleItems,
  setRangeValues,
  searchTerm,
}: GooglePriceRangeDropdownProps) => {
  const { min, max } = priceRange;
  const [currentMin, setCurrentMin] = useState(min);
  const [currentMax, setCurrentMax] = useState(max);
  const [isSaleChecked, setIsSaleChecked] = useState(false);

  const isRefined = currentMin !== min || currentMax !== max;

  useEffect(() => {
    setCurrentMin(min);
    setCurrentMax(max);
    setRangeValues?.({ min, max });
  }, [min, max]);

  const onRefine = ({ currentMin: newMin, currentMax: newMax }: { currentMin: number; currentMax: number }) => {
    setCurrentMin(newMin);
    setCurrentMax(newMax);
    setPriceRange({ min: newMin, max: newMax });
  };

  const onSaleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsSaleChecked(e.target.checked);
    setSaleItems(e.target.checked);
  };

  if (min === 0 && max === 0) return null;

  return (
    <PriceRangeDropdownShell
      nbHits={nbHits}
      isRefined={isRefined}
      currentMin={currentMin}
      currentMax={currentMax}
      searchTerm={searchTerm}
    >
      {showDropdown => (
        <>
          <DoubleRangeSlider
            showDollar
            nbHits={nbHits}
            showDropdown={showDropdown}
            min={min}
            max={max}
            currentMin={currentMin}
            currentMax={currentMax}
            onRefine={onRefine}
          />
          <label className={`sale-items ${nbSaleItems === 0 ? 'hidden' : ''}`}>
            <input type="checkbox" checked={isSaleChecked} onChange={onSaleToggle} />
            Sale items
            <span> ({nbSaleItems})</span>
          </label>
        </>
      )}
    </PriceRangeDropdownShell>
  );
};

export default GooglePriceRangeDropdown;
